import { Component, OnInit } from '@angular/core';
import { CartitemsService } from '../providers/cartitems.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { LanguageService } from '../providers/lang.service';
import { Input } from '@angular/core';
import { RestApiServices } from '../providers/rest.service';
import { Constant } from '../Constant';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Toast, ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { BrowserModule } from '@angular/platform-browser';

@Component({
  selector: 'cartlist',
  templateUrl: './cart-list.component.html',
  styleUrls: ['./cart-list.component.css']
})
export class CartListComponent implements OnInit {
  itemQuantity = true
  public edited = false;
  btcheck: boolean = false;
  localCartItem: [{}]
  private imageUrl: string = environment.imageUrl;
  productDetails: any = {}
  cartItemsCount = 0;
  shoppingdialog = false;
  cartlist = [];
  totalItems: number;
  Emptycart: boolean = false;
  showDialog: boolean = false;
  recommendedproducts = [];
  inspired: string = ""; item_number: string = ""; quantity: string = ""; remove: string = "";
  checkout: string = ""; empty_cart: string = ""; or: string = ""; cart_subtotal: string = "";
  items: string = ""; yes: string = ""; no: string = ""; empty_list: string = ""; remove_item: string = "";
  inStock = '';lbl_uom : string = "";lbl_qty : string = ""; lbl_pack: string = "Pack Size";lbl_pallet_quantity: string = "Pallet Quantity"; lbl_free_boxes: string = "Free Quantity";
  in_stock: any

  private toasterService: ToasterService;
  public config: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-center',
    limit: 1,
    tapToDismiss: false,
    timeout: 1000

  });
  @Input('product') product: {};
  shoppinglabel: string = "";
  removeitem: any;
  modifiedquantity = [];
  constructor(public router: Router, toasterService: ToasterService, private localCart: CartitemsService, private restApi: RestApiServices, private localStorage: CustomStorage, private langService: LanguageService) {
    this.toasterService = toasterService;
  }
  @Input() cartItems = [];
  wasClicked = false;


  ngOnInit() {
    this.langService.getJson().subscribe(data => {
      this.setLabels();
      this.localStorage.getItem(Constant.KEY_TOPSELLINGITEM).subscribe(data => {
        if (data != null && data != undefined) {
          //console.log(data);
          this.recommendedproducts = data.response.inspiredby_purchasing_history;
        }
      });
      this.localStorage.getItem('productSelected').subscribe(data => {
        if (data != null && data != undefined) {
          //console.log(data);
          this.productDetails = data;
        }
      });
    });
    this.cartItemsCount = this.localCart.getCartItemsCount();
    this.localCart.cartList.subscribe(res => {
      if (res !== undefined && res.length > 0) {
        // let myCartItems = res;
        let v = [];
        // this.cartItems = res;
        res.forEach(element => {
          if (element) {
            element['edited'] = false;
            v.push(element);
          }
        });

        this.cartItems = res;
        this.cartItemsCount = this.cartItems.length;

        if (this.modifiedquantity.length == 0)
        {
          for (let item of this.cartItems){
            //console.log(item);
            let cartEdited = { originalQuantity: item.quantity, unique_id: item.unique_id};
            this.modifiedquantity.push(cartEdited);
          }
        }
      }
    });

    this.localCart.loadCartItems();
    //console.log(this);

  }
  removeItemFromCart(product) {
    this.removeitem = product;
    //this.showDialog = true;
    this.localCart.removeCartItem(this.removeitem);
    this.restApi.removeCartItems(this.removeitem).subscribe(data => {
    })
    //    this.showDialog = false;

  }

  getquntitycheck(){
    for(let item of  this.cartItems){
      if(item.quantity == 0){
      return true;
     // console.log("quantity"+item.quantity);
      }
    }
    return false;
  }
  setLabels() {

    this.langService.getLangLabelValue("LblInspiredByPurchasingHistory").then(result => {
      this.inspired = result;
    });

    this.langService.getLangLabelValue("LblQuantity").then(result => {
      this.quantity = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result;
    });
    this.langService.getLangLabelValue("LblRemove").then(result => {
      this.remove = result;
    });
    this.langService.getLangLabelValue("LblCheckout").then(result => {
      this.checkout = result;
    });
    this.langService.getLangLabelValue("LblEmptyCart").then(result => {
      this.empty_cart = result;
    });
    this.langService.getLangLabelValue("LblOr").then(result => {
      this.or = result;
    });
    this.langService.getLangLabelValue("LblCartSubtotal").then(result => {
      this.cart_subtotal = result;
    });
    this.langService.getLangLabelValue("Lblitems").then(result => {
      this.items = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("LblEmptyCartMessage").then(result => {
      this.empty_list = result;
    });
    this.langService.getLangLabelValue("LblRemoveItemMessage").then(result => {
      this.remove_item = result;
    });
    this.langService.getLangLabelValue("LblShoppingCart").then(res => {
      this.shoppinglabel = res;
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;  
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;  
    });
  }

  getTotalQuantity() {
    let totalcartamount = this.localCart.getCartItems();
    //console.log(totalcartamount.map(item => item.quantity + this.calculateFreeBoxes(item)));
    const bArray = totalcartamount.map(item => Number(item.quantity + this.calculateFreeBoxes(item)));
    //console.log(bArray.reduce(function (a, b) { return a + b; }, 0));
    const result = bArray.reduce(function (a, b) { return a + b; }, 0);
    return result;
  }

  getTotalCartAmount() {
    let totalcartamount = this.localCart.getCartItems();
    const bArray = totalcartamount.map(item => this.getSubTotalItemPrice(item));
    const result = bArray.reduce(function (a, b) { return a + b; }, 0);
    return result;
  }

  getSubTotalItemPrice(item){
      let subTotalItemPrice = item.quantity * item.unit_price;
      let discount = this.calculateItemDiscount(item);
      // console.log(discount);
      return subTotalItemPrice - discount;
  }

  calculateItemDiscount(item){
      let up_to_qty1 = item.up_to_qty1;
      let up_to_qty2 = item.up_to_qty2;
      let up_to_qty3 = item.up_to_qty3;
      let up_to_qty4 = item.up_to_qty4;
      let up_to_qty5 = item.up_to_qty5;
    
      let up_to_price1 = item.up_to_price1;
      let up_to_price2 = item.up_to_price2;
      let up_to_price3 = item.up_to_price3;
      let up_to_price4 = item.up_to_price4;
      let up_to_price5 = item.up_to_price5;
    
      let item_percent_for_disc = item.item_percent_for_disc;

      let subTotalPrice = item.quantity * item.unit_price;

      if (up_to_qty1 > 0 || up_to_qty2 > 0 || up_to_qty3 > 0 || up_to_qty4 > 0 || up_to_qty5 > 0) {
        if (item.quantity >= up_to_qty1 && item.quantity < up_to_qty2) {
            return subTotalPrice * up_to_price1 / 100.0; 
        } else if (item.quantity >= up_to_qty2 && item.quantity < up_to_qty3) {
            return subTotalPrice * up_to_price2 / 100.0; 
        } else if (item.quantity >= up_to_qty3 && item.quantity < up_to_qty4) {
            return subTotalPrice * up_to_price3 / 100.0; 
        } else if (item.quantity >= up_to_qty4 && item.quantity < up_to_qty5) {
            return subTotalPrice * up_to_price4 / 100.0; 
        } else if (item.quantity >= up_to_qty5) {
            return subTotalPrice * up_to_price5 / 100.0;  
        } else {
          return 0;
        }
      }
      else {
        return 0;
      }
  }

  calculateFreeBoxes(item){
    let freeBoxes = 0;
    let buy_qty_to_get_free = item.buy_qty_to_get_free;
    let get_free_item = item.get_free_item;

    if (item.quantity >= buy_qty_to_get_free) {
      freeBoxes = get_free_item * ~~(Number(item.quantity) / buy_qty_to_get_free);
    }
    return freeBoxes;
  }

  trackByFn(index: number, item: any): any {
    return item.unique_id
  }

  determineIfEdited(uniqueId){
    for (let index = 0; index < this.cartItems.length; index++){
      if (uniqueId == this.cartItems[index].unique_id && uniqueId == this.modifiedquantity[index].unique_id){
        this.modifiedquantity[index].edited = true;
      }
    }
  }

  emptylist() {
    this.localCart.removeAllCartItems();
    this.cartItems = [];
    this.Emptycart = false;

  }
  isCartEmpty() {
    return this.cartItems.length == 0
    
  }
  dialogempty(){
   if(this.cartItems.length == 0){
    this.Emptycart = false;
   }
  }
  numberofcartitems() {
    this.totalItems = this.cartItems.length;
    return this.totalItems;
  }
  // removeitems(){
  //    this.localCart.removeCartItem(this.removeitem);
  //    this.restApi.removeCartItems(this.removeitem).subscribe(data=>{

  //    })
  //    this.showDialog = false;
  // }


  itemSelected(item) {
    this.localStorage.setItem('productSelected', item).subscribe(res => {
      this.router.navigate(['/cartdetails']);
    });
  }

  modify(event, cartItem) {
    // console.log(cartItem.quantity)
    let itemQuantity = parseInt(event.target.value);
    // console.log(event.target.value);
    // console.log(cartItem);
    if (cartItem.product_info) {
      for (let idx = 0; idx < cartItem.product_info.more_product_data.length; idx++) {
        if (cartItem.item_size == cartItem.product_info.more_product_data[idx].size) {
          if (cartItem.item_color == cartItem.product_info.more_product_data[idx].color) {
            this.in_stock = cartItem.product_info.more_product_data[idx].in_stock;
          }
        }
      }
    }
    //if (cartItem.quantity > 0 && cartItem.quantity <= this.in_stock) {
    if (cartItem.quantity > 0 && cartItem.quantity <= cartItem.product_info.qty_on_hand) {
      this.itemQuantity = true;
      this.isInvalid()
      // console.log(this.itemQuantity)
      this.restApi.modifyCartItems({ "quantity": itemQuantity, "unique_id": cartItem.unique_id }).subscribe(data => {
        // this.wasClicked= !this.wasClicked;

      })
      cartItem.edited = true;
      setTimeout(function () {
        cartItem.edited = false;
      }.bind(this), 1000);
      // this.wasClicked = !this.wasClicked
    }

    else if (cartItem.quantity < 1 || cartItem.quantity == undefined){
      cartItem.edited = true;
      this.itemQuantity = false;
      this.removeItemFromCart(cartItem);
      setTimeout(function () {
        cartItem.edited = false;
      }.bind(this), 1000);
    }

    // else {
    //   this.itemQuantity = false;
    //   this.isInvalid()
    //   let currentQuantity = 0;
    //   for (let item of this.modifiedquantity)
    //   {
    //     if (item.unique_id == cartItem.unique_id){
    //       currentQuantity = Number(item.quantity);
    //     }
    //   }
    //   // console.log(this.itemQuantity)
    //   this.restApi.modifyCartItems({ "quantity": currentQuantity, "unique_id": cartItem.unique_id }).subscribe(data => {
    //     // this.wasClicked= !this.wasClicked;

    //   })
    //   cartItem.edited = true;
    //   // setTimeout(function () {
    //   //   cartItem.edited = false;
    //   // }.bind(this), 1000);
    //   // this.wasClicked = !this.wasClicked
    
    // }

    else {
      this.itemQuantity = false;
      this.isInvalid()
      // console.log(this.itemQuantity)
      this.restApi.modifyCartItems({ "quantity": cartItem.quantity, "unique_id": cartItem.unique_id }).subscribe(data => {
        // this.wasClicked= !this.wasClicked;

      })
      cartItem.edited = true;
      // setTimeout(function () {
      //   cartItem.edited = false;
      // }.bind(this), 1000);
      // this.wasClicked = !this.wasClicked
    
    }

  }

  onClick(item) {
    this.wasClicked = !this.wasClicked;
  }

  isInvalid() {
    // console.log(this.itemQuantity)
    return this.itemQuantity
  }

  popToast() {
    var toast: Toast = {
      type: 'info',
      title: 'description',
      body: 'modified data successfully'
    };

    this.toasterService.pop(toast);
  }

  saveTodos(): void {
    //show box msg
    this.edited = true;
    //wait 3 Seconds and hide
    setTimeout(function () {
      this.edited = false;
    }.bind(this), 5000);
  }

}



// WEBPACK FOOTER //
// ./src/app/cart-list/cart-list.component.ts